/* eslint-disable vue/html-indent */
<template>
  <div
    itemscope
    itemtype="https://schema.org/Product"
    class="page-game-offers">
    <div
      v-if="
        ((activeCategory && activeCategory.seo) || (game && game.seo)) &&
          !usePageRoute
      "
      class="page-content page-description">
      <h1
        v-if="
          activeCategory &&
            activeCategory.seo &&
            activeCategory.seo.h1.length > 0
        ">
        {{ activeCategory.seo.h1 }}
      </h1>
      <h1 v-if="!activeCategory && game && game.seo && game.seo.h1.length > 0">
        {{ game.seo.h1 }}
      </h1>

      <div
        v-if="
          activeCategory &&
            activeCategory.seo &&
            activeCategory.seo.text.length > 0
        "
        class="page-description-text"
        v-html="activeCategory.seo.text"/>
      <div
        v-if="!activeCategory && game && game.seo && game.seo.text.length > 0"
        class="page-description-text"
        v-html="game.seo.text"/>
    </div>
    <div class="page-content">
      <div
        v-if="!usePageRoute"
        class="offers-head">
        <img
          v-if="game && game.icon != null"
          itemprop="image"
          :src="backendUrl + '/img/game/' + game.icon + '?v=' + game.updated_at"
          width="32"
          height="32"
          :alt="
            activeCategory
              ? activeCategory.name + ' ' + game.name
              : 'Все предложения ' + game.name
          "
          @error.self="replaceGameIconByDefault">
        <img
          v-else
          :src="'/img/game-no-icon.png'">
        <div class="game-content">
          <h1
            v-if="game"
            itemprop="name">
            {{ seoTitle ? seoTitle : game.name }}
            <span>
              {{ offersCount }}
            </span>
          </h1>
          <div
            v-if="game.parent"
            class="sub-games">
            <span
              v-for="child in game.parent.children"
              :key="child.id"
              :class="'child' + (game.id == child.id ? ' active' : '')">
              <nuxt-link
                :to="{ path: '/games/' + child.id + '-' + slugify(child.name) }">
                {{ getChildName(game.parent.name, child.name) }}
              </nuxt-link>
            </span>
          </div>
          <div
            v-if="seoDescription.length > 0"
            class="description">
            {{ seoDescription }}
          </div>
        </div>
      </div>

      <categoriesSwiper
        :key="swiperKey"
        :game="game"
        :categories="categories"
        :user="user"
        :use-page-route="usePageRoute"
        :path="path"/>
      <div style="display: flex;border-top:2px solid #eff1f4; width: 100%;justify-content: center;">
        <anylvl
          :message="`Покупай ${activeCategory && activeCategory.name ? `${activeCategory.name}` : `товары ${game.name}`} на ANYLVL`"
          :button-link="`https://anylvl.com/ru?search=${activeCategory && activeCategory.name ? activeCategory.name : game.name}&ref=gobuffy`"
          :sub-message="'Все предложения gobuffy теперь хранятся на ANYLVL'"
          button-message="Посмотреть все предложения"/>
      </div>
      <filters
        v-if="
          false
          // activeCategory &&
          //   activeCategory.attrs &&
          //   ((filterPriceAndTimeAttributes &&
          //   filterPriceAndTimeAttributes.length > 0) ||
          //   (filterAttributesNoAffects && filterAttributesNoAffects.length > 0))
        "
        :ref="'filters'"
        :key="'filters-'"
        :game="game"
        :active-category="activeCategory"
        :categories="categories"
        :user="user"
        :use-page-route="usePageRoute"
        :path="path"/>
      <div
        v-if="false"
        ref="offers"
        itemprop="offers"
        itemscope
        itemtype="https://schema.org/AggregateOffer"
        class="offers">
        <span
          itemprop="offerCount"
          style="display: none">
          {{ offers ? offersCount : 0 }}
        </span>
        <noitems
          v-if="
            !offers ||
              !offers.items ||
              (offers && offers.items && offers.items.length == 0)
          "
          :button-link="
            noitemsButtonLink +
              (game && activeCategory
                ? '?gameId=' + game.id + '&categoryId=' + activeCategory.id
                : '')
          "
          :check-auth="true"
          :check-email="true"
          button-message="Создать предложение"
          message="В этой категории пока нет предложений"
          sub-message="Есть что предложить? Создайте своё предложение"
          class="offers-empty"/>
        <div
          v-if="offers && offers.items && offers.items.length > 0"
          class="offers-table">
          <div class="offers-table-head clearfix">
            <div class="offers-table-col offers-table-col-user">
              <span>Рейтинг и продавец</span>
            </div>
            <div class="offers-table-col offers-table-col-title">
              <span>Заголовок</span>
            </div>
            <div class="offers-table-col offers-table-col-availability">
              <span>Мин/всего</span>
            </div>
            <div class="offers-table-col offers-table-col-price">
              <span>Цена</span>
            </div>
            <div class="offers-table-col offers-table-col-time">
              <span>Срок</span>
            </div>
          </div>
          <client-only>
            <div
              v-if="adsList && adsList.items && adsList.items.length > 0"
              class="ads">
              <div
                v-for="(userAd, index) in adsList.items"
                :key="'ad-line-' + index"
                class="offers-table-line clearfix">
                <img
                  class="marker-img"
                  src="/svg/orange-marker.svg">
                <div
                  :key="'rating-line' + index"
                  class="offers-table-col offers-table-col-user">
                  <rating
                    :value="
                      userAd.user.rating ? userAd.user.rating.toString() : null
                    "
                    :reviews-count="Number(userAd.user.reviewsCount)"
                    class="table-rating"/>
                  <user
                    :id="parseInt(userAd.user.id)"
                    :key="index + userAd.user.id + userAd.user.username"
                    v-b-tooltip
                    :title="userAd.user.username"
                    :name="userAd.user.username"
                    :premium="userAd.user.premium_expired_at"
                    :filter="
                      game && game.id
                        ? '?gameId=' +
                          game.id +
                          (activeCategory
                            ? '&categoryId=' + activeCategory.id
                            : '')
                        : ''
                    "
                    :avatar="
                      userAd.user.photo_uploaded_at
                        ? backendUrl +
                          getUserPhoto(
                            userAd.user.id,
                            userAd.user.photo_uploaded_at
                          )
                        : null
                    "
                    :status="userAd.user.online"
                    class="offers-table-user"
                    @hitAd="
                      hitAd(
                        userAd,
                        '/profile/' +
                          userAd.user.id +
                          '/' +
                          (game && game.id
                            ? '?gameId=' +
                              game.id +
                              (activeCategory
                                ? '&categoryId=' + activeCategory.id
                                : '')
                            : '') +
                          '#offers'
                      )
                    "/>
                </div>
                <div
                  :key="'category-line' + index"
                  class="offers-table-col offers-table-col-title table-ad-title">
                  <div>
                    <div class="offer-category">
                      <a
                        href="javascript.void(0)"
                        @click.prevent="
                          hitAd(
                            userAd,
                            '/profile/' +
                              userAd.user.id +
                              '/' +
                              (game && game.id
                                ? '?gameId=' +
                                  game.id +
                                  (activeCategory
                                    ? '&categoryId=' + activeCategory.id
                                    : '')
                                : '') +
                              '#offers'
                          )
                        ">
                        ⭐ Рекламное объявление
                      </a>
                    </div>
                    <a
                      href="javascript.void(0)"
                      class="offer-category-name"
                      @click.prevent="
                        hitAd(
                          userAd,
                          '/profile/' +
                            userAd.user.id +
                            '/' +
                            (game && game.id
                              ? '?gameId=' +
                                game.id +
                                (activeCategory
                                  ? '&categoryId=' + activeCategory.id
                                  : '')
                              : '') +
                            '#offers'
                        )
                      ">
                      {{ userAd.title }}
                    </a>
                  </div>
                </div>
                <div class="offers-table-col offers-table-col-buttons">
                  <a
                    class="btn btn-outline-secondary"
                    @click.prevent="
                      hitAd(
                        userAd,
                        '/profile/' +
                          userAd.user.id +
                          '/' +
                          (game && game.id
                            ? '?gameId=' +
                              game.id +
                              (activeCategory
                                ? '&categoryId=' + activeCategory.id
                                : '')
                            : '') +
                          '#offers'
                      )
                    ">
                    Перейти к предложению
                  </a>
                </div>
              </div>
            </div>
          </client-only>
          <div
            v-for="(offer, index) in offers.items"
            :key="'offers-line-' + index"
            itemprop="offers"
            itemscope
            itemtype="https://schema.org/Offer"
            class="offers-table-line clearfix">
            <div
              :key="'rating-line' + index"
              class="offers-table-col offers-table-col-user">
              <rating
                :value="offer.user.rating ? offer.user.rating.toString() : null"
                :reviews-count="Number(offer.user.reviewsCount)"
                class="table-rating"/>
              <user
                :id="parseInt(offer.user.id)"
                :key="index + offer.user.id + offer.user.username"
                v-b-tooltip
                :title="offer.user.username"
                :name="offer.user.username"
                :premium="offer.user.premium_expired_at"
                :filter="
                  game && game.id
                    ? '?gameId=' +
                      game.id +
                      (activeCategory ? '&categoryId=' + activeCategory.id : '')
                    : ''
                "
                :avatar="
                  offer.user.photo_uploaded_at
                    ? backendUrl +
                      getUserPhoto(offer.user.id, offer.user.photo_uploaded_at)
                    : null
                "
                :status="offer.user.online"
                class="offers-table-user"/>
            </div>
            <div
              :key="'category-line' + index"
              class="offers-table-col offers-table-col-title">
              <div>
                <div class="offer-category">
                  <nuxt-link
                    v-if="
                      activeCategory &&
                        game &&
                        offer &&
                        offer.category &&
                        activeCategory.id == offer.category.id
                    "
                    :to="
                      usePageRoute
                        ? $i18n.path(
                          'profile/' +
                            user.id +
                            '/' +
                            '?gameId=' +
                            offer.game.id +
                            '&categoryId=' +
                            offer.category.id
                        )
                        : $i18n.path(
                          'games/' +
                            game.id +
                            '-' +
                            slugify(offer.game.name) +
                            '/' +
                            offer.category.id +
                            '-' +
                            slugify(offer.category.name) +
                            '/' +
                            offer.id +
                            '-' +
                            slugify(offer.name + ' ' + offer.name_user)
                        )
                    ">
                    {{ offer.category.name }}
                  </nuxt-link>
                  <nuxt-link
                    v-else
                    :to="
                      usePageRoute
                        ? $i18n.path(
                          'profile/' +
                            user.id +
                            '/' +
                            '?gameId=' +
                            offer.game.id +
                            '&categoryId=' +
                            offer.category.id
                        )
                        : $i18n.path(
                          'games/' +
                            offer.game.id +
                            '-' +
                            slugify(offer.game.name) +
                            '/' +
                            offer.category.id +
                            '-' +
                            slugify(offer.category.name)
                        )
                    ">
                    {{ offer.category.name }}
                  </nuxt-link>
                </div>
                <nuxt-link
                  v-if="offer.game"
                  itemprop="url"
                  :content="
                    $i18n.path(
                      'games/' +
                        offer.game.id +
                        '-' +
                        slugify(offer.game.name) +
                        '/' +
                        offer.category.id +
                        '-' +
                        slugify(offer.category.name) +
                        '/' +
                        offer.id +
                        '-' +
                        slugify(offer.name + ' ' + offer.name_user)
                    )
                  "
                  :to="
                    $i18n.path(
                      'games/' +
                        offer.game.id +
                        '-' +
                        slugify(offer.game.name) +
                        '/' +
                        offer.category.id +
                        '-' +
                        slugify(offer.category.name) +
                        '/' +
                        offer.id +
                        '-' +
                        slugify(offer.name + ' ' + offer.name_user)
                    )
                  "
                  class="offer-category-name">
                  <span
                    itemprop="description"
                    :content="
                      offer.category.name +
                        ' ' +
                        offer.game.name +
                        ' ' +
                        offer.name +
                        ' ' +
                        offer.name_user
                    ">
                    {{ offer.name + " " + offer.name_user }}
                  </span>
                </nuxt-link>
              </div>
            </div>
            <div
              :key="'sum-line' + index"
              class="offers-table-col offers-table-col-availability">
              <div>
                <span
                  v-b-tooltip
                  itemprop="price"
                  :content="
                    offer.minimum_sum ? offer.minimum_sum.toFixed(2) : '0.00'
                  "
                  title="Минимальная сумма, от которой продавец выполняет заказы">
                  {{
                    offer.minimum_sum == null ? "0" : offer.minimum_sum + " "
                  }}
                  <span
                    itemprop="priceCurrency"
                    content="RUB"> руб. </span>
                </span>
                <template v-if="offer.count == 0">
                  <span
                    v-b-tooltip
                    title="Товара нет в наличии"
                    itemprop="availability"
                    content="0"
                    class="availability-no">
                    / Нет в наличии
                  </span>
                </template>
                <template v-if="offer.count < 0">
                  <span
                    v-b-tooltip
                    itemprop="availability"
                    content="999999"
                    title="Продавец может продать любое количество товара или услуг">
                    / Неограниченно
                  </span>
                </template>
                <template v-if="offer.count > 0">
                  <span
                    v-b-tooltip
                    itemprop="availability"
                    :content="offer.count"
                    title="Доступное количество товара или услуг">
                    / {{ offer.count }}
                  </span>
                </template>
              </div>
            </div>

            <!-- Если фикисрованная цена у офера-->
            <div
              v-if="offer.category.show_price == 1"
              :key="'price-line' + index"
              class="offers-table-col offers-table-col-price">
              <div
                itemprop="price"
                :content="offer.price ? offer.price.toFixed(2) : '0.00'">
                {{ offer.price }} руб.
                <span
                  v-if="offer.category.price_multiplier != 1"
                  class="offer-multiplier">
                  за {{ offer.category.price_multiplier }} ед.
                </span>
              </div>
            </div>
            <!-- Если цену нужно расчитать -->
            <div
              v-else
              :key="'calc-price' - index"
              class="offers-table-col offers-table-col-price">
              <!-- Если прошел расчет цены - показываем ее либо ошибки (price-and-time) -->
              <template v-if="offer.calculatedPrice != null">
                <template v-if="offer.calculatedPrice.errors.length != 0">
                  <span
                    v-if="offer.category.show_time == 1"
                    class="calc-warning">Продавец не выполняет заказы с введенными параметрами</span>
                </template>
                <template v-else>
                  {{ offer.calculatedPrice.value }} руб.
                </template>
                <span
                  v-if="offer.category.price_multiplier != 1"
                  class="offer-multiplier">
                  за {{ offer.category.price_multiplier }} ед.
                </span>
              </template>

              <!-- Если еще не было расчета и задано время у офера
                   показываем dropdown расчета  в колонке с ценой-->
              <template
                v-if="
                  offer &&
                    !offer.calculatedPrice &&
                    (!offer.price || offer.price == 0) &&
                    (offer.time || (offer.category.show_time == 1 && !offer.time))
                ">
                <b-dropdown
                  :id="'id' + offer.id"
                  ref="dropdown"
                  variant="link"
                  right
                  no-caret
                  no-flip
                  class="calculate"
                  @shown="calculateOffer(offer.category_id, index)">
                  <template slot="button-content">
                    Рассчитать <br>цену и срок
                  </template>
                  <b-dropdown-form>
                    <b-dropdown-header>Рассчитать цену</b-dropdown-header>
                    <div class="calculate-block">
                      <calculate
                        v-if="offer.game"
                        :key="'calculate-' + offer.category_id + '-' + offer.id"
                        :category-id="offer.category_id"
                        :category-name="offer.category.name"
                        :offer-id="offer.id"
                        :attributes="offer.attrs"
                        :game="offer.game"
                        :index="index"
                        :for-all="true"
                        :calculate-ready="calculateReady"
                        :calculate-all-ready="calculateAllReady"
                        :get-filters-component="getFiltersComponent"
                        :link="
                          usePageRoute
                            ? $i18n.path(
                              path +
                                '/' +
                                user.id +
                                '/?gameId=' +
                                offer.game.id +
                                '&categoryId=' +
                                offer.category.id
                            )
                            : $i18n.path(
                              path +
                                '/' +
                                offer.game.id +
                                '-' +
                                slugify(offer.game.name) +
                                '/' +
                                offer.category.id +
                                '-' +
                                slugify(offer.category.name)
                            )
                        "/>
                    </div>
                  </b-dropdown-form>
                </b-dropdown>
              </template>
            </div>

            <!-- Если фикисрованное время у офера-->
            <div
              v-if="offer && offer.category && offer.category.show_time == 1"
              :key="'time-line' + index"
              class="offers-table-col offers-table-col-time">
              <template
                v-if="
                  offer.category.is_instant_delivery == 1 && offer.time == 0
                ">
                <span
                  v-b-tooltip
                  class="time-instantly"
                  title="Данные будут доступны сразу после оплаты">
                  Мгновенно
                </span>
              </template>
              <template v-else>
                {{ (offer.time / 60).toFixed(1) }} ч.
              </template>
            </div>

            <!-- Если время нужно расчитать -->
            <div
              v-if="offer && offer.category && offer.category.show_time != 1"
              :key="'col-time-line' + index"
              class="offers-table-col offers-table-col-time">
              <template v-if="offer.calculatedTime != null">
                <template v-if="offer.calculatedTime.errors.length != 0">
                  <span
                    class="calc-warning">Продавец не выполняет заказы с введенными параметрами</span>
                </template>
                <template v-else>
                  {{ (offer.calculatedTime.value / 60).toFixed(1) }} ч.
                </template>
              </template>
              <template
                v-if="
                  offer &&
                    offer.category &&
                    (!offer.price || offer.price == 0 || !offer.time) &&
                    !offer.calculatedTime
                ">
                <b-dropdown
                  :id="'id' + offer.id"
                  ref="dropdown"
                  v-b-tooltip
                  title="Цена зависит от исходных параметров - нужно произвести расчет"
                  variant="link"
                  right
                  no-caret
                  no-flip
                  class="calculate"
                  @shown="calculateOffer(offer.category_id, index)">
                  <template slot="button-content">
                    Рассчитать <br>цену и срок
                  </template>
                  <b-dropdown-form>
                    <b-dropdown-header>Рассчитать цену</b-dropdown-header>
                    <div class="calculate-block">
                      <calculate
                        v-if="offer.game"
                        :key="'calculate-' + offer.category_id + '-' + offer.id"
                        :category-id="offer.category_id"
                        :category-name="offer.category.name"
                        :offer-id="offer.id"
                        :attributes="offer.attrs"
                        :game="offer.game"
                        :index="index"
                        :for-all="true"
                        :calculate-ready="calculateReady"
                        :calculate-all-ready="calculateAllReady"
                        :get-filters-component="getFiltersComponent"
                        :link="
                          usePageRoute
                            ? $i18n.path(
                              path +
                                '/' +
                                user.id +
                                '/?gameId=' +
                                offer.game.id +
                                '&categoryId=' +
                                offer.category.id
                            )
                            : $i18n.path(
                              path +
                                '/' +
                                offer.game.id +
                                '-' +
                                slugify(offer.game.name) +
                                '/' +
                                offer.category.id +
                                '-' +
                                slugify(offer.category.name)
                            )
                        "/>
                    </div>
                  </b-dropdown-form>
                </b-dropdown>
              </template>
            </div>

            <!-- Если офер посчитан выводим иконку для изменения параметров расчета -->
            <template
              v-if="
                offer.calculateStatus &&
                  (!offer.price || offer.price == 0 || !offer.time)
              ">
              <b-dropdown
                :id="'id' + offer.id"
                :key="'calc-status' + index"
                ref="dropdown"
                variant="link"
                right
                no-caret
                no-flip
                class="calculate calculate-change"
                @shown="calculateOffer(offer.category_id, index)">
                <template slot="button-content">
                  Рассчитать <br>цену и срок
                </template>
                <b-dropdown-form>
                  <b-dropdown-header>Рассчитать цену</b-dropdown-header>
                  <div class="calculate-block">
                    <calculate
                      v-if="offer.game"
                      :key="'calculate-' + offer.category_id + '-' + offer.id"
                      :category-id="offer.category_id"
                      :category-name="offer.category.name"
                      :offer-id="offer.id"
                      :attributes="offer.attrs"
                      :index="index"
                      :game="offer.game"
                      :for-all="true"
                      :calculate-ready="calculateReady"
                      :calculate-all-ready="calculateAllReady"
                      :get-filters-component="getFiltersComponent"
                      :link="
                        usePageRoute
                          ? $i18n.path(
                            path +
                              '/' +
                              user.id +
                              '/?gameId=' +
                              offer.game.id +
                              '&categoryId=' +
                              offer.category.id
                          )
                          : $i18n.path(
                            path +
                              '/' +
                              offer.game.id +
                              '-' +
                              slugify(offer.game.name) +
                              '/' +
                              offer.category.id +
                              '-' +
                              slugify(offer.category.name)
                          )
                      "/>
                  </div>
                </b-dropdown-form>
              </b-dropdown>
            </template>
          </div>
        </div>
      </div>
      <template>
        <pagination
          v-if="false"
          :page-count="offers._meta.pageCount"
          :current-page="offers._meta.currentPage"
          class="offers-pagination"/>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import pagination from "~/components/base/pagination.vue";
import calculate from "~/components/offer/calculate/calculate.vue";
import rating from "~/components/base/rating.vue";
import user from "~/components/base/user.vue";
import categoriesSwiper from "~/components/offer/categoriesSwiper/categoriesSwiper.vue";
import filters from "~/components/offer/filters/filters.vue";
import axios from "axios";
import { getPhoto } from "~/services/base";
import noitems from "~/components/tables/noItems.vue";
import anylvl from "~/components/tables/anylvl.vue";
import { prepareAttributesCalculateOffer } from "~/services/prepareAttributesCalculateOffer";

export default {
  components: {
    calculate,
    rating,
    user,
    pagination,
    noitems,
    anylvl,
    categoriesSwiper,
    filters,
  },
  props: {
    gameId: {
      type: String,
      default: "",
    },
    games: {
      type: Array,
      default: () => [],
    },
    offersCount: {
      type: Number,
      default: 0,
    },
    game: {
      type: Object,
      default: null,
    },
    categories: {
      type: Array,
      default: null,
    },
    usePageRoute: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: null,
    },
    noitemsButtonLink: {
      type: String,
      default: null,
    },
    noitemsButtonMessage: {
      type: String,
      default: null,
    },
    noitemsMessage: {
      type: String,
      default: null,
    },
    noitemsSubMessage: {
      type: String,
      default: null,
    },
    adsList: {
      type: Object,
      default: null,
    },
    path: {
      type: String,
      default: "",
    },
    seoTitle: {
      type: String,
      default: null,
    },
    seoDescription: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      calculateAll: false,
      backendUrl: process.env.backendUrl,
      swiperLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
      offers: "offerList/getOffers",
      calculateCategoryAttrs: "offerList/getCalculateCategoryAttrs",
      calculateCategoryOffers: "offerList/getCalculateCategoryOffers",
      calculateCategoryId: "offerList/getCalculateCategoryId",
      calculateCategoryName: "offerList/getCalculateCategoryName",
      activeCategory: "offerList/getActiveCategory",
    }),
    swiperKey() {
      let key = "swiper-";
      if (this.activeCategory) {
        key = key + this.activeCategory.id;
        if (this.activeCategory.children) {
          this.activeCategory.children.forEach((element) => {
            key = key + element.id;
          });
        }
      } else {
        if (this.categories) {
          this.categories.forEach((element) => {
            key = key + element.id;
          });
        }
      }

      return key;
    },
    filterPriceAndTimeAttributes() {
      return this.activeCategory && this.activeCategory.attrs
        ? this.activeCategory.attrs.filter(
            (item) => item.affects_time == 1 || item.affects_price == 1
          )
        : null;
    },

    filterAttributesNoAffects() {
      return this.activeCategory && this.activeCategory.attrs
        ? this.activeCategory.attrs.filter(
            (item) =>
              item.is_filter == 1 &&
              item.affects_time == 0 &&
              item.affects_price == 0
          )
        : null;
    },

    frequentAttributes() {
      return this.activeCategory && this.activeCategory.attrs
        ? this.activeCategory.attrs.filter(
            (item) =>
              item.is_frequent == 1 ||
              (item.is_frequent == 0 &&
                item.filters &&
                item.filters.nothing == false)
          )
        : null;
    },
  },
  watch: {
    $route() {
      Object.assign(this.$data, this.$options.data());
    },
  },
  methods: {
    calculateReady: function (data) {
      this.$store.dispatch("offerList/CALCULATE_READY", data);
      this.$forceUpdate();
    },
    calculateOffer: function (categoryId, index) {
      if (this.offers.items[index].attrs.length != 0) return;
      return axios
        .get("/categories/" + categoryId + "?expand=attrs")
        .then((response) => {
          if (response.data.success) {
            this.$store.dispatch("offerList/SET_OFFERS_ITEM_ATTR", {
              index: index,
              attrs: prepareAttributesCalculateOffer(response.data.data.attrs),
            });
          }
        });
    },
    calculateAllReady: function (data) {
      this.$store.dispatch("offerList/SET_OFFERS_META", {});
      if (this.calculateCategoryAttrs) {
        this.$store.dispatch(
          "offerList/SET_ACTIVECATEGORY_CALCULATE_ATTRIBUTES",
          {
            id: this.activeCategory.id,
            attrs: this.calculateCategoryAttrs.slice(),
          }
        );
      }

      if (!this.$route.params.category && !this.usePageRoute) {
        this.$router.push({
          path:
            this.game.id +
            "-" +
            this.slugify(this.game.name) +
            "/" +
            data.categoryId +
            "-" +
            this.slugify(data.categoryName),
        });
      } else {
        this.$store.dispatch(
          "offerList/SET_OFFERS_ITEMS",
          this.calculateCategoryOffers
        );
      }
    },
    getUserPhoto: function (userId, uploadedAt) {
      return getPhoto(userId, uploadedAt);
    },
    async hitAd(userAd, path) {
      await this.$store.dispatch("ads/HIT_AD", {
        id: userAd.id,
        sign: userAd.sign,
        time: userAd.time,
        categoryId: this.activeCategory ? parseInt(this.activeCategory.id) : 0,
      });
      this.$router.push({
        path: path,
      });
    },
    getChildName(rootName, name) {
      let diff = (diffMe, diffBy) => diffMe.split(diffBy).join("");
      return diff(name, rootName).trim();
    },
    getFiltersComponent() {
      return this.$refs["filters"];
    },
  },
};
</script>

<style lang="scss" scoped>
.offers {
  min-height: 330px;
  margin-top: 0;
}
.offers-head {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-top: 29px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 20px;
  img {
    margin-right: 16px;
  }
  .game-content {
    display: flex;
    flex-direction: column;
    max-width: 650px;
    h1 {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0;
      font-size: 20px;
      font-weight: 500;
      color: #2d303a;
      span {
        margin-left: 7px;
        display: inline-block;
        padding: 0 8px;
        font-size: 12px;
        line-height: 21px;
        color: #a8aaaf;
        background: #eff1f4;
        border-radius: 12px;
      }
    }
    .sub-games {
      display: flex;
      margin-top: 2px;
    }
    .description {
      color: $grey;
      margin-top: 14px;
      size: 12px;
    }
  }
}

.offers-add {
  position: relative;
  width: 176px;
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  font-weight: 500;
  background: $green;
  border-radius: 4px;
  text-align: center;
  color: #ffffff;
  padding-left: 40px;
  &:before {
    position: absolute;
    top: 50%;
    left: 25px;
    margin-top: -12px;
    content: "";
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNUg5TTUgMVY5IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K");
    background-color: rgba(#ffffff, 0.3);
    background-repeat: no-repeat;
    background-position: center;
  }
}

.offers-table {
  margin-top: -2px;
  border-top: 2px solid #eff1f4;
}

.offers-table-head {
  position: relative;
  padding-top: 5px;
  padding-bottom: 7px;
  background: #f7f9fc;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  .offers-table-col {
    color: #a8aaaf;
    span {
      position: relative;
      &:after {
        position: absolute;
        top: 50%;
        left: 100%;
        margin-top: -3px;
        margin-left: 5px;
        content: "";
        //background: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSI3cHgiIHZpZXdCb3g9IjAgMCAxMCA3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1MS4yICg1NzUxOSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+U2hhcGU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iVmVjdG9yLTcuNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wMDAwMDAsIDEuMDAwMDAwKSIgZmlsbD0iI0E4QUFBRiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTcuMjkyODkzMjIsLTAuNzA3MTA2NzgxIEM3LjY4MzQxNzUxLC0xLjA5NzYzMTA3IDguMzE2NTgyNDksLTEuMDk3NjMxMDcgOC43MDcxMDY3OCwtMC43MDcxMDY3ODEgQzkuMDk3NjMxMDcsLTAuMzE2NTgyNDg5IDkuMDk3NjMxMDcsMC4zMTY1ODI0ODkgOC43MDcxMDY3OCwwLjcwNzEwNjc4MSBMNCw1LjQxNDIxMzU2IEwtMC43MDcxMDY3ODEsMC43MDcxMDY3ODEgQy0xLjA5NzYzMTA3LDAuMzE2NTgyNDg5IC0xLjA5NzYzMTA3LC0wLjMxNjU4MjQ4OSAtMC43MDcxMDY3ODEsLTAuNzA3MTA2NzgxIEMtMC4zMTY1ODI0ODksLTEuMDk3NjMxMDcgMC4zMTY1ODI0ODksLTEuMDk3NjMxMDcgMC43MDcxMDY3ODEsLTAuNzA3MTA2NzgxIEw0LDIuNTg1Nzg2NDQgTDcuMjkyODkzMjIsLTAuNzA3MTA2NzgxIFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+");
        width: 10px;
        height: 7px;
      }
    }
  }
  .offers-table-col-title {
    min-height: inherit;
  }
  .offers-table-col-time {
    padding-right: 40px;
  }
  .offers-table-col-price {
    padding-right: 20px;
  }
}
.offers-table-line {
  position: relative;
  font-size: 14px;
  color: #a8aaaf;
  border-bottom: 2px solid #eff1f4;
  transition: $link-transition;
  &:last-child {
    border-bottom: 0;
  }
  &:hover {
    background: rgba(#eff1f4, 0.3);
    .calculate-change {
      opacity: 1;
    }
  }
}
.offers-table-col {
  float: left;
  display: flex;
  height: 100%;
  flex-wrap: wrap;
  align-items: center;
}
.offers-table-col-user {
  position: absolute;
  top: 0;
  left: 0;
  width: 242px;
  height: 100%;
  padding-left: 16px;
  display: flex;
  align-items: center;
}
.offers-table-col-title {
  width: 100%;
  padding-left: 250px;
  padding-right: 360px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-top: 10px;
  padding-bottom: 8px;
  min-height: 78px;
  color: #2d303a;
}
.table-ad-title {
  padding-right: 0;
  overflow: hidden;
  width: 795px;
}
.ads {
  padding-bottom: 10px;
  background: #e5e5e5;
  .offers-table-line {
    background: white;
  }
}
.offers-table-col-buttons {
  width: 189px;
  position: absolute;
  top: 0;
  right: 16px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .btn-outline-secondary {
    background: #098aff;
    color: white;
    border: none;
  }
}
.offers-table-col-availability {
  position: absolute;
  top: 0;
  right: 230px;
  width: 130px;
  height: 100%;
  span:not(:first-child) {
    display: block;
    font-size: 12px;
    color: #a8aaaf;
  }
}
.availability-no {
  color: $red;
}
.offers-table-col-price {
  position: absolute;
  top: 0;
  right: 160px;
  width: 100px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: $body-color;
}

.offers-pagination {
  padding: 20px;
}

.offers-table-col-time {
  position: absolute;
  top: 0;
  right: 0;
  width: 160px;
  height: 100%;
  padding-right: 22px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: $body-color;
}
.table-rating {
  margin-right: 16px;
  display: flex;
  flex-direction: column;
}
.offers-table-img {
  position: relative;
  width: 32px;
  height: 32px;
  margin-right: 16px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}

.offers-category-main {
  margin-bottom: 0;
  padding: 0 16px;
  font-size: 14px;
  list-style: none;
  li {
    margin-right: 32px;
    display: inline-block;
    &:last-child {
      margin-right: 0;
    }
  }
}
.offers-category-link {
  position: relative;
  display: inline-block;
  padding: 10px 0;
  color: #a8aaaf;
  &:after {
    position: absolute;
    content: "";
    bottom: -2px;
    left: 0;
    right: 0;
    height: 2px;
    background: $blue;
    opacity: 0;
  }
  &.active {
    color: $blue;
    &:after {
      opacity: 1;
    }
  }
}
.offers-category {
  position: relative;
  min-height: 64px;
  //padding-right: 66px;
  //border-bottom: 2px solid #EFF1F4;
  border-top: 2px solid #eff1f4;
}
.offers-category-back {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  cursor: pointer;
  z-index: 10;
  width: 230px;
  padding-left: 70px;
  text-align: center;
  border-right: 2px solid #eff1f4;
  + .offers-category-wrapper {
    padding-left: 200px;
  }
}
.offers-category-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.offers-category-back-link {
  position: absolute;
  display: block;
  top: 16px;
  left: 16px;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background-color: #eff1f4;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSI4cHgiIHZpZXdCb3g9IjAgMCAxMiA4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1MS4yICg1NzUxOSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+U2hhcGU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iVmVjdG9yLTkuMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wMDAwMDAsIDIuMDAwMDAwKSIgZmlsbD0iI0E4QUFBRiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlNoYXBlIiBwb2ludHM9IjUgMS40MTQyMTM1NiAwLjcwNzEwNjc4MSA1LjcwNzEwNjc4IC0wLjcwNzEwNjc4MSA0LjI5Mjg5MzIyIDUgLTEuNDE0MjEzNTYgMTAuNzA3MTA2OCA0LjI5Mjg5MzIyIDkuMjkyODkzMjIgNS43MDcxMDY3OCI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+");
}
.offers-category-slider {
  position: relative;
  width: 100%;
  &:after {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
    width: 160px;
    height: 100%;
    background: linear-gradient(
      to left,
      #ffffff 20%,
      rgba(255, 255, 255, 0.001)
    );
    z-index: 2;
  }
}

.swiper-link {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
  font-size: 14px;
  width: 100%;
  color: #a8aaaf;
  overflow: hidden;
  cursor: pointer;
  &:before {
    position: absolute;
    content: "";
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: #098aff;
    transition: $link-transition;
    opacity: 0;
  }
  &:after {
    position: absolute;
    content: "";
    top: 0;
    bottom: 0;
    right: 0;
    width: 2px;
    background: #eff1f4;
  }
  &:hover {
    color: #6e7279;
    &:before {
      opacity: 0.3;
    }
  }
  &.active {
    color: $blue;
    &:before {
      opacity: 1;
    }
  }
}

.swiper-slide {
  max-width: 150px;
  width: 100%;
  &:last-child {
    .swiper-link {
      &:after {
        display: none;
      }
    }
  }
}
.offers-category-next {
  position: absolute;
  top: 50%;
  right: 16px;
  margin-top: -20px;
  width: 40px;
  height: 40px;
  background-color: #eff1f4;
  outline: 1px solid transparent;
  border-radius: 50%;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTAgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUxLjIgKDU3NTE5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5TaGFwZTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJWZWN0b3ItNy4xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMS4wMDAwMDApIiBmaWxsPSIjNkU3Mjc5IiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8cGF0aCBkPSJNLTAuMjA3MTA2NzgxLDEuNDU3MTA2NzggQy0wLjU5NzYzMTA3MywxLjA2NjU4MjQ5IC0wLjU5NzYzMTA3MywwLjQzMzQxNzUxMSAtMC4yMDcxMDY3ODEsMC4wNDI4OTMyMTg4IEMwLjE4MzQxNzUxMSwtMC4zNDc2MzEwNzMgMC44MTY1ODI0ODksLTAuMzQ3NjMxMDczIDEuMjA3MTA2NzgsMC4wNDI4OTMyMTg4IEw4LjE2NDIxMzU2LDcgTDEuMjA3MTA2NzgsMTMuOTU3MTA2OCBDMC44MTY1ODI0ODksMTQuMzQ3NjMxMSAwLjE4MzQxNzUxMSwxNC4zNDc2MzExIC0wLjIwNzEwNjc4MSwxMy45NTcxMDY4IEMtMC41OTc2MzEwNzMsMTMuNTY2NTgyNSAtMC41OTc2MzEwNzMsMTIuOTMzNDE3NSAtMC4yMDcxMDY3ODEsMTIuNTQyODkzMiBMNS4zMzU3ODY0NCw3IEwtMC4yMDcxMDY3ODEsMS40NTcxMDY3OCBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==");
}

.swiper-slide-last {
  width: 80px;
  height: 17px;
  display: block;
}

.active-category {
  padding-left: 65px;
  line-height: 64px;
  color: #6e7279;
}

.calculate-block {
  min-height: 50px;
}
.swiper-container {
  width: 100%;
  padding-right: 66px;
}

.group-status {
  display: inline-block;
  vertical-align: middle;
  margin-right: 3px;
  margin-top: -2px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: $grey-light;
  &.active {
    background: $green;
  }
}

.offer-category {
  display: block;
  a {
    color: $blue;
    font-size: 12px;
    cursor: pointer;
    transition: $link-transition;
    border-bottom: 1px solid transparent;
    &:hover {
      border-bottom: 1px solid rgba($blue, 0.7);
    }
  }
}
.offer-multiplier {
  display: block;
  font-size: 12px;
  color: #a8aaaf;
}

a.offer-category-name {
  color: $body-color;
}

.time-instantly {
  &:before {
    margin-right: 5px;
    display: inline-block;
    vertical-align: middle;
    width: 10px;
    height: 20px;
    content: "";
    background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC43IiBkPSJNMCAwVjExSDNWMjBMMTAgOEg2TDEwIDBIMFoiIGZpbGw9IiNGRkIwMDAiLz4KPC9zdmc+Cg==");
  }
}

.offers-empty {
  padding-top: 52px;
  padding-bottom: 52px;
  text-align: center;
  border-top: 2px solid #eff1f4;
  color: #6e7279;
  h2 {
    margin-top: 30px;
    color: $body-color;
  }
}
.offers-empty-link {
  display: inline-block;
  padding-left: 35px;
  &:before {
    left: 12px;
  }
}
.empty-icon {
  display: inline-block;
  width: 84px;
  height: 83px;
  background: url("data:image/svg+xml;base64,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");
}

.page-description {
  margin-top: 64px;
  h1 {
    margin: 0;
    padding: 23px 16px;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #2d303a;
    border-bottom: 2px solid #eff1f4;
  }
}
.page-description-text {
  padding: 17px 16px 5px;
}

.offers-category-active {
  padding-left: 80px;
}

.active-category-title {
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
  line-height: 1.1;
}

.calc-warning {
  display: block;
  font-size: 12px;
  line-height: 14px;
  font-weight: 500;
  color: #6e7279;
  align-items: right;
}

.page-game-offers {
  display: flex;
  flex-direction: column-reverse;
}

.ad-title {
  cursor: pointer;
}

.child {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #a8aaaf;

  &:not(:last-child) {
    border-right: solid 1px rgba(168, 170, 175, 0.3);
  }

  padding-right: 8px;

  &:not(:first-child) {
    padding-left: 8px;
  }

  &.active a {
    color: #098aff;
  }

  &:hover a {
    color: #6e7279;
  }

  a {
    color: #a8aaaf;
  }
}
</style>
